import { Box, Typography } from "@material-ui/core";
import { platformTokens } from '@roc/feature-app-core';
import { Card } from "@roc/ui";
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@roc/ui';
import { Edit } from '@material-ui/icons';
import { DateFormat, formatDate } from '@roc/client-portal-shared/utils';

// tokens are read inside makeStyles (not at module load) because of a circular import with feature-app-core
const useStyles = makeStyles(theme => {
  const { color, radius } = platformTokens;
  return {
    noteCard: {
      borderRadius: radius.lg,
      border: `1px solid ${color.neutral100}`,
      boxShadow: 'none',
    },
    noteHeader: {
      padding: theme.spacing(1.5, 1, 1, 2),
      borderBottom: `1px solid ${color.neutral100}`,
      '& .MuiCardHeader-title': {
        fontSize: 16,
        fontWeight: 600,
        color: color.heading,
      },
      '& .MuiCardHeader-action': {
        margin: 0,
        alignSelf: 'center',
      },
    },
    noteTime: {
      display: 'block',
      textAlign: 'right',
      fontSize: 12,
      lineHeight: '18px',
      color: color.subtle,
    },
  };
});

export const Note = ({ title, onEdit, children, createdDate, lastUpdatedDate, createdBy, lastModifiedBy }) => {
  const classes = useStyles();
  const action = (
    <>
      <IconButton testId="edit" size="small" onClick={onEdit}>
        <Edit fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Card
      title={title}
      className={classes.noteCard}
      titleTypographyProps={{ variant: 'h6' }}
      cardHeaderProps={{
        action,
        className: classes.noteHeader,
      }}
      cardContentProps={{ style: { padding: '12px 16px' } }}
    >
      {children}
      {(createdDate || lastUpdatedDate) ? (
        <Box pt={2}>
          <Typography variant="subtitle2" className={classes.noteTime}>
            {createdDate && <>Created by {createdBy} at {formatDate(createdDate,null)}<br /></>}
            {lastUpdatedDate && <>Last updated by {lastModifiedBy} at {formatDate(lastUpdatedDate, null)}</>}
          </Typography>
        </Box>
      ) : null}
    </Card>
  );
}